import { gql, useMutation } from '@apollo/client';
import { notification } from 'antd';
import React, { useCallback, useState } from 'react';
import YesNoModal from '../../../../components/YesNoModal';

export const removeContactFromHouseholdMutation = gql`
  mutation RemoveContactFromHousehold($contactId: ID!, $householdId: ID!) {
    removeContactFromHousehold(contactId: $contactId, householdId: $householdId)
  }
`;

function RemoveFromHouseholdModalModal({ visible, onDone, onCancel }) {
  const { contact, household } = visible || {};

  const [saving, setSaving] = useState(false);
  const [removeContactFromHousehold] = useMutation(
    removeContactFromHouseholdMutation,
  );

  const handleFinish = useCallback(async () => {
    setSaving(true);
    try {
      await removeContactFromHousehold({
        variables: {
          contactId: contact._id,
          householdId: household._id,
        },
      });
      notification.success({
        message: 'Success',
        description: 'Contact successfully removed',
      });
      onDone();
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Error',
        description: 'There was an error removing contact from household',
      });
    }
    setSaving(false);
  }, [contact, household, removeContactFromHousehold, onDone]);

  return (
    <YesNoModal
      title="Remove Contact from Household"
      question={`Are you sure you want to remove ${contact?.fullName} from the household ${household?.fullName}?`}
      yesText="Remove"
      noText="Cancel"
      onYes={handleFinish}
      onNo={onCancel}
      visible={!!contact}
      loading={saving}
    />
  );
}

export default RemoveFromHouseholdModalModal;
